import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  SCOPES: string;
  CLIENT_ID: string;
  BASE_URL: string;
  START_PAGE_URL: string;
  RADIX_ENVIRONMENT: string;
  APPINSIGHTS_CONNECTION_STRING: string;
  /** Comma- or semicolon-separated recipients for the header Feedback button. */
  FEEDBACK_EMAIL?: string;
  HARMONIA_GRADE_LINK?: string;
}

export const ENVIRONMENT = new InjectionToken<EnvironmentConfig>('ct-app.environment');
